import { z } from 'zod';
import { validatedGet, validatedPost, validatedPut, validatedDelete } from '../api-client.ts';
import { buildExportQuery } from '../utils.ts';
import { DelegaAltroTerritorioArricchitaSchema } from '@/types/entities/delega-altro-territorio.ts';
import type { DelegaAltroTerritorioBodySchema } from '@/types/entities/delega-altro-territorio.ts';
import { OkResult } from './shared.ts';

const BASE = 'deleghe-altri-territori';

const ListaResult = z.object({
  deleghe: z.array(DelegaAltroTerritorioArricchitaSchema),
  count: z.number(),
  page: z.number(),
  totalPages: z.number(),
  pageSize: z.number(),
});

export type DelegaAltroTerritorioBodyInput = z.input<typeof DelegaAltroTerritorioBodySchema>;

export const delegheAltriTerritoriApi = {
  /** `params`: page, limit, q, territorioId, dataRegistrazioneDa/A (valori vuoti omessi) */
  lista: (params: Record<string, string>) =>
    validatedGet(`${BASE}/lista?${buildExportQuery(params)}`, ListaResult),

  dettaglio: (id: number) =>
    validatedGet(`${BASE}/${id}`, DelegaAltroTerritorioArricchitaSchema),

  crea: (body: DelegaAltroTerritorioBodyInput) =>
    validatedPost(BASE, body, DelegaAltroTerritorioArricchitaSchema),

  aggiorna: (id: number, body: DelegaAltroTerritorioBodyInput) =>
    validatedPut(`${BASE}/${id}`, body, DelegaAltroTerritorioArricchitaSchema),

  elimina: (id: number) =>
    validatedDelete(`${BASE}/${id}`, OkResult),
};
